/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable jsx-a11y/media-has-caption */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import React from "react";
import "./styles.scss";

export const Videos = (): JSX.Element => (
  <div className="videos">
    <div className="videos-wrapper">
      <div className="dome" />
      <div className="videos-dome">
        <div className="videos-info">
          <h1>This is the future iGEM!</h1>
          <p>
            <a href="http://2021.igem.org/" target="_blank" rel="noreferrer">
              Welcome to the official start of the 2021 iGEM season!
            </a>{" "}
            There are currently over 300 teams like yours, just starting out the
            rollercoaster journey through iGEM and Synthetic Biology. Over the
            next few months, you will design, build, and test your ideas. You
            are local people solving local problems all over the world, with the
            power of Synthetic Biology. We may not be able to meet yet, but we
            will one day. In the meantime, make this iGEM Opening Weekend
            Festival an occasion, take a moment and celebrate with your team
            before the madness begins. You only start iGEM once. See you on May
            15th - Good luck and have fun!
          </p>
        </div>
        <iframe
          title="trailer"
          src="https://video.igem.org/videos/embed/8d3e5a31-de22-4686-a91f-5f54f43ffa9a?title=0&warningTitle=0&peertubeLink=0"
          frameBorder="0"
          allowFullScreen
          sandbox="allow-same-origin allow-scripts allow-popups"
        />
      </div>
    </div>
  </div>
);
